import React from 'react';
import ReactDOM from 'react-dom';
import { StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import "react-datepicker/dist/react-datepicker.css";  
import './index.css';   //After react-datepicker .css to override
import App from './App';

//Distinct productionPrefix keeps this app's JSS class names from colliding with form-builder's (both use @material-ui/core styling)
const generateClassName = createGenerateClassName({
  productionPrefix: 'agp',
  seed: 'accountPortal',
});

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider generateClassName={generateClassName}>
      <App/>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

